import _StoreData from './storedata.json';

interface Data {
    [key: string]: DataStore[];
}
interface DataStore {
    item: string;
    shelf_life: number;
    lead_time: number;
    values: DataOrderedByShelf;
    prep: number[][];
    actual_waste: number[];
    actual_stockout: number[];
}

interface DataOrderedByShelf {
    [key: string]: DataOrderedByLead;
}

interface DataOrderedByLead {
    [key: string]: Datum;
}

interface Datum {
    prioritization: number;
    waste: number[][];
    stockout: number[][];
    waste_amount: number[][];
    stockout_amount: number[][];
}

const StoreData = _StoreData as Data;

function data_waste(
    leadTimes: number[],
    shelfLifes: number[],
    sliders: number[]
) {
    return [0, 1, 2, 3].map((counter) => {
        return {
            week: `Week ${counter + 1}`,
            Current: StoreData.s7002
                .reduce((accumulator: number, object) => {
                    return accumulator + object.actual_waste[counter];
                }, 0)
                .toFixed(),
            CurrentColor: 'hsl(200, 50%, 80%)',
            Predicted: StoreData.s7002
                .reduce((accumulator: number, object, index: number) => {
                    return (
                        accumulator +
                        object.values[leadTimes[index]][shelfLifes[index]]
                            .waste_amount[sliders[index]][counter]
                    );
                }, 0)
                .toFixed(),
            PredictedColor: 'hsl(200, 70%, 50%)',
        };
    });
}

function data_stockout(
    leadTimes: number[],
    shelfLifes: number[],
    sliders: number[]
) {
    return [0, 1, 2, 3].map((counter) => {
        return {
            week: `Week ${counter + 1}`,
            Current: StoreData.s7002.reduce((accumulator: number, object) => {
                return accumulator + object.actual_stockout[counter];
            }, 0),
            CurrentColor: 'hsl(200, 50%, 80%)',
            Predicted: StoreData.s7002.reduce(
                (accumulator: number, object, index: number) => {
                    return (
                        accumulator +
                        object.values[leadTimes[index]][shelfLifes[index]]
                            .stockout[sliders[index]][counter]
                    );
                },
                0
            ),
            PredictedColor: 'hsl(200, 70%, 50%)',
        };
    });
}

function data_heatmap(
    leadTimes: number[],
    shelfLifes: number[],
    sliders: number[]
) {
    return StoreData.s7002.map((item, index) => {
        let wasteTemp, stockoutTemp;
        return {
            id: item.item,
            data: [
                {
                    x: 'Waste',
                    y: (wasteTemp = item.values[leadTimes[index]][
                        shelfLifes[index]
                    ].waste_amount[sliders[index]].reduce(
                        (accumulator: any, value: any) => {
                            return accumulator + value;
                        },
                        0
                    )),
                },
                {
                    x: 'Stock Out',
                    y: (stockoutTemp = item.values[leadTimes[index]][
                        shelfLifes[index]
                    ].stockout[sliders[index]].reduce(
                        (accumulator: any, value: any) => {
                            return accumulator + value;
                        },
                        0
                    )),
                },
                {
                    x: 'Ratio',
                    y: stockoutTemp !== 0 ? wasteTemp / stockoutTemp : null,
                },
            ],
        };
    });
}

const data_shelflife_default: number[] = StoreData.s7002.map(
    (item: DataStore) => {
        return item.shelf_life;
    }
);

const data_shelflife_options: string[][] = StoreData.s7002.map(
    (item: DataStore) => {
        return Object.keys(item.values);
    }
);

const data_leadtime_default: number[] = StoreData.s7002.map(
    (item: DataStore) => {
        return item.lead_time;
    }
);

const data_leadtime_options: string[][] = StoreData.s7002.map(
    (item: DataStore, index: number) => {
        return Object.keys(item.values[data_shelflife_default[index]]);
    }
);

const data_prioritization_default: number[] = StoreData.s7002.map(
    (item: DataStore) => {
        return item.values[item.lead_time][item.shelf_life].prioritization;
    }
);

function data_preplist(sliders: number[], leadTimes: number[]) {
    return StoreData.s7002.map((item: DataStore, index: number) => {
        return {
            name: item.item,
            leadTime: leadTimes[index],
            prepAmount: item.prep[sliders[index]].slice(
                leadTimes[index] - 1,
                leadTimes[index] + 6
            ),
        };
    });
}

export {
    data_waste,
    data_stockout,
    data_heatmap,
    data_shelflife_default,
    data_shelflife_options,
    data_leadtime_default,
    data_leadtime_options,
    data_prioritization_default,
    data_preplist,
};
